import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from "@angular/core";
import { IAdaptLinkObject } from "@common/route/route.service";
import { IActivitySection } from "@org-common/lib/activities/activities-metadata";
import { CulturalLeadershipFrameworkAuthService } from "@org-common/lib/cultural-leadership/cultural-leadership-framework-auth.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "adapt-activity-section-collapsible",
    templateUrl: "./activity-section-collapsible.component.html",
    styleUrl: "./activity-section-collapsible.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ActivitySectionCollapsibleComponent implements OnInit {
    @Input({ required: true }) public section!: IActivitySection;
    @Input() public count = 0;
    @Input() public totalCount?: number;
    @Input() public countTooltip?: string;
    @Input() public fallbackText = "Great work, nothing is due.";
    @Input() public isLoading = false;

    @Input() public error?: any;

    @HostBinding("style.--activity-accent") public get activityAccent() {
        return this.section!.colourAccent;
    }

    public linkObject?: IAdaptLinkObject;

    public constructor(
        private culturalLeadershipFrameworkAuthService: CulturalLeadershipFrameworkAuthService,
    ) {}

    public get countText() {
        if (this.totalCount && this.totalCount > this.count) {
            return `${this.count}+`;
        }

        if (this.count === 0) {
            return "-";
        }

        return this.count.toString();
    }

    public async ngOnInit() {
        if (this.section.route$ && !this.section.routeRequiresTeamId) {
            const personIsCulturalLeader = this.culturalLeadershipFrameworkAuthService.currentPersonHasPermissionToReadCohorts();

            this.linkObject = await lastValueFrom(this.section.route$(undefined, personIsCulturalLeader));
        }
    }
}
